import { EvaluationError, FunctionDoesNotExistError, InvalidFunctionNameError } from '../errors';
import { FunctionLoader } from '../functions/function-loader';
import { NativeInput, TransformationContext, TransformationEvaluator } from '../interfaces';

/**
 * Execute native transformation functions
 */
export class NativeEvaluator implements TransformationEvaluator<NativeInput> {
  constructor(private functionLoader: FunctionLoader = new FunctionLoader()) {}

  /**
   * Execute a native function
   * @param context The execution context
   *
   * @throws {EvaluationError} Native function execution failed for "<function name>".
   */
  async evaluate(context: TransformationContext<NativeInput>): Promise<unknown> {
    try {
      const fn = this.lookupFunction(context.input.function);
      return Promise.resolve(fn.apply({}, context.input.arguments ? context.input.arguments : [])).catch(err => {
        throw new EvaluationError(`Native function execution failed for "${context.input?.function}"`, err);
      });
    } catch (err) {
      return Promise.reject(
        new EvaluationError(`Native function execution failed for "${context.input?.function}"`, err)
      );
    }
  }

  private lookupFunction(functionName: string): () => unknown {
    if (!functionName) throw new InvalidFunctionNameError(functionName);

    const resolvedFunction = this.functionLoader.functions[functionName];
    if (resolvedFunction) {
      return resolvedFunction;
    }

    throw new FunctionDoesNotExistError(functionName);
  }
}
